// AI generated
import { Handle, Position } from '@xyflow/react'

/**
 * The four source handles every node carries. The ids `a`/`b`/`c`/`d` are
 * persisted in edges — do not rename them.
 */
const HANDLES = [
  { id: 'a', position: Position.Top },
  { id: 'b', position: Position.Left },
  { id: 'c', position: Position.Bottom },
  { id: 'd', position: Position.Right },
] as const

/**
 * Handles stay mounted in read-only mode, just invisible, so edges keep their anchors.
 */
export function NodeHandles({ isVisible }: { isVisible: boolean }) {
  return (
    <>
      {HANDLES.map(({ id, position }) => (
        <Handle
          key={id}
          id={id}
          type="source"
          position={position}
          style={{ opacity: isVisible ? 1 : 0, zIndex: 1 }}
        />
      ))}
    </>
  )
}
